module.exports = __webpack_public_path__ + "static/img/papers_banner.f1c7457.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/papers_banner.jpg
// module id = w/G7
// module chunks = 5